import React from 'react'
import { BiLogoWhatsapp } from "react-icons/bi";

function GalleryPage() {
  return (
    <section id="home" className="d-flex align-items-center homePage">
      <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=919535117707&text=Hi, Hoolla's Trekking!" class="whatsapp-button"><BiLogoWhatsapp/></a>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 order-2 order-lg-1 d-flex flex-column justify-content-center">
            <div className='homeSection aboutInOther'>
              <h3 className="fontColor-1">GALLERY</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GalleryPage
